import React, { useEffect, FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Router as RouterType } from 'router5'
import { RouterProvider } from 'react-router5'
import CssBaseline from '@material-ui/core/CssBaseline'
import Loading from './components/system/Loading'
import Snackbar from './components/system/Snackbar'
import GlobalLoading from './components/system/GlobalLoading'

import networkSelectors from './store/selectors/network'
import systemSelectors from './store/selectors/system'
import systemActions from './store/modules/system'
import authActions from './store/modules/auth'

import {
  ThunkDispatcher,
} from './types/store'

import Router from './router/Router'

interface AppProps {
  router: RouterType,
}

const App: FC<AppProps> = ({
  router,
  children,
}) => {
  const dispatch = useDispatch()
  const thunkDispatch = dispatch as ThunkDispatcher
  const initialised = useSelector(systemSelectors.initialised)
  const globalLoading = useSelector(networkSelectors.globalLoading)

  useEffect(() => {
    const initialise = async () => {
      const urlParams = new URLSearchParams(window.location.search)
      const token = urlParams.get('token')
      //await thunkDispatch(authActions.authenticate(token || ''))
      await thunkDispatch(systemActions.initialise())
      router.start()
    }
    initialise()
  }, [])

  if(!initialised) {
    return (
      <Loading />
    )
  }

  return (
    <RouterProvider router={ router }>
      <CssBaseline />
      <Router>
        { children }
      </Router>
      <GlobalLoading {...globalLoading} />
      <Snackbar />
    </RouterProvider>
  )
}

export default App
